import HomeComponent from "./HomePage";
import "./rubic.js";

function App() {
  return (
    <HomeComponent />
  );
}

export default App;